// eslint-disable-next-line import/prefer-default-export
import { REACT_APP_ENV } from "../constants/environments";

const isNonProd = () =>
  typeof window !== "undefined" &&
  window.environment?.REACT_APP_ENV !== REACT_APP_ENV.production;

const readUrlParam = () => {
  if (typeof window === "undefined" || !window.location) return null;
  return new URLSearchParams(window.location.search).get("enable_brand_refresh");
};

export const isBrandRefreshEnabled = () => {
  if (isNonProd()) {
    const param = readUrlParam();
    if (param === "1" || param === "true") {
      try {
        window.sessionStorage.setItem("sp_brand_refresh_override", "1");
      } catch (e) {
        // sessionStorage unavailable; ignore
      }
      return true;
    }
    if (param === "0" || param === "false") {
      try {
        window.sessionStorage.setItem("sp_brand_refresh_override", "0");
      } catch (e) {
        // sessionStorage unavailable; ignore
      }
      return false;
    }
    try {
      const override = window.sessionStorage.getItem("sp_brand_refresh_override");
      if (override === "1") return true;
      if (override === "0") return false;
    } catch (e) {
      // sessionStorage unavailable; ignore
    }
  }
  const fromWindow = window.environment?.REACT_APP_BRAND_REFRESH_ENABLED;
  if (fromWindow === "true") {
    return true;
  }
  if (fromWindow === "false") {
    return false;
  }
  // Fallback to process.env (CRA-inlined) when window value is missing.
  return process.env.REACT_APP_BRAND_REFRESH_ENABLED === "true";
};
